import moment from "moment";
import { Message } from "element-ui";
export default {
  /**
   * @param {string} name url中的key
   * @returns {string|null} 返回null或string
   */
  getUrlParams(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); //定义正则表达式
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  /**
   * 函数去抖
   * @param {function} func
   * @param {number} delay
   */
  debounce(func, delay) {
    var tId;
    return function () {
      var context = this;
      var arg = arguments;
      if (tId) clearTimeout(tId);
      tId = setTimeout(function () {
        func.apply(context, arg);
      }, delay);
    };
  },
  /**
   * 函数节流
   * @param {function} func
   * @param {number} delay
   */
  throttle(func, delay) {
    var timer = null;
    var startTime = Date.now();
    return function () {
      var curTime = Date.now();
      var remaining = delay - (curTime - startTime);
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      if (remaining <= 0) {
        func.apply(context, args);
        startTime = Date.now();
      } else {
        timer = setTimeout(func, remaining);
      }
    };
  },
  /**
   * 列表导出通用
   * @param {Object} json api参数
   * @param {Number} type 1导出  2下载
   */
  exportExcle(api, json, fileName, path, type = 1) {
    api(json).then((res) => {
      if (res.data.code == 0) {
        let urlstr = "";
        if (!res.data.data) {
          Message.error("未找到相关文件！");
        } else {
          if (type == 1) {
            urlstr = path + res.data.data.urlName;
          } else {
            urlstr = path + res.data.data.fileName;
          }
          this.downloadFile(fileName, urlstr);
        }
      } else {
        Message.error(res.data.msg);
      }
    });
  },
  /**
   * 文件下载
   * @param {String} fileName
   * @param {String} url
   */
  downloadFile(fileName, url) {
    var elemA = document.createElement("a");
    elemA.href = encodeURI(url);
    elemA.setAttribute("target", "_blank");
    document.body.appendChild(elemA);
    elemA.click();
    elemA.remove();
  },
  /**
   * 文件导入方法
   * @param {Function} api
   * @param {Number} type  1.新入列表导入 2.正式员工列表打入 3.退休人员 4.离职
   * @param {Object} vm vue this
   */
  importFile(api, type, vm) {
    var input = document.createElement("input");
    input.type = "file";
    input.name = "type";
    input.accept =
      "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    input.onchange = () => {
      vm.tableLoading = true;
      let params = new FormData();
      params.append("multipartFile", input.files[0]);
      params.append("state", type);
      api(params)
        .then((res) => {
          vm.tableLoading = false;
          if (res.data.code == 0) {
            Message.success(res.data.msg);
            vm.getTable();
          } else {
            Message.error(res.data.msg);
          }
        })
        .catch(() => {
          vm.tableLoading = false;
        });
    };
    input.click();
  },
  /**
   *
   * @param {String} timestamp
   * @param {String} format
   * @param {Boolean} isFull
   */
  formatDate(timestamp, format, isFull) {
    format = format || "YYYY-MM-DD";
    if (isFull) {
      format += " HH:mm:ss";
    }
    if (timestamp) {
      return moment(timestamp, "X").format(format);
    }
    return "--";
  },
  callResponse(vm, res) {
    vm.loading = false;
    if (res.data.code == 0) {
      vm.$emit("success");
      vm.$emit("end");
      vm.$message({ message: res.data.msg, type: "success" });
    } else {
      vm.$message({ message: res.data.msg, type: "error" });
    }
  },
  /**
   * @returns Number 返回table最大高度
   */
  getTableMaxHeight() {
    var arr = [
      45, //padding+留白
      document.querySelector(".admin-table-search")
        ? document.querySelector(".admin-table-search").offsetHeight
        : 0,
      document.querySelector(".admin-methods-btns")
        ? document.querySelector(".admin-methods-btns").offsetHeight
        : 0,
      document.querySelector(".main-header")
        ? document.querySelector(".main-header").offsetHeight
        : 0,
      document.querySelector(".admin-pager-container")
        ? document.querySelector(".admin-pager-container").offsetHeight
        : 0,
    ];
    var bodyHeight = document.body.offsetHeight;
    arr.map((item) => {
      bodyHeight -= item;
    });
    return bodyHeight;
  },
  /**
   * 加法函数，避免小数丢失精度
   */
  decimalsAdd() {
    var args = arguments, //获取所有的参数
      d = 0, //定义小数位的初始长度，默认为整数，即小数位为0
      sum = 0; //定义sum来接收所有数据的和
    //循环所有的参数
    for (var key in args) {
      //遍历所有的参数
      //把数字转为字符串
      var str = "" + args[key];
      if (str.indexOf(".") != -1) {
        //判断数字是否为小数
        //获取小数位的长度
        var temp = str.split(".")[1].length;
        //比较此数的小数位与原小数位的长度，取小数位较长的存储到d中
        d = d < temp ? temp : d;
      }
    }
    //计算需要乘的数值
    var m = Math.pow(10, d);
    //遍历所有参数并相加
    for (var cell in args) {
      sum += args[cell] * m;
    }
    //返回结果
    return sum / m;
  },
  /**
   * 小数相乘，解决丢失精度问题
   * @param {Number} value1
   * @param {Number} value2
   */
  accMul(value1, value2) {
    if (value1 == 0 || value2 == 0) {
      return 0;
    }
    let m = 0;
    let v1 = value1.toString();
    let v2 = value2.toString();
    m += v1.split(".")[1] ? v1.split(".")[1].length : 0;
    m += v2.split(".")[1] ? v2.split(".")[1].length : 0;
    let _v1 = Number(v1.replace(".", ""));
    let _v2 = Number(v2.replace(".", ""));
    return (_v1 * _v2) / Math.pow(10, m);
  },
  /**
   * 小数除法，解决丢失精度问题
   * @param {Number} value1 除数
   * @param {*} value2 被除数
   */
  accDiv(value1, value2) {
    if (value1 == 0) {
      return 0;
    }
    let v1 = value1.toString();
    let v2 = value2.toString();
    let m1 = v1.split(".")[1] ? v1.split(".")[1].length : 0;
    let m2 = v2.split(".")[1] ? v2.split(".")[1].length : 0;
    let _v1 = Number(v1.replace(".", ""));
    let _v2 = Number(v2.replace(".", ""));
    return this.accMul(_v1 / _v2, Math.pow(10, m2 - m1));
  },
  isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
  },
  checkEmpty(val) {
    if (!val || val.replace(/(^s*)|(s*$)/g, "").length == 0) {
      return true;
    }
    return false;
  },
  checkEmail(val) {
    //对电子邮件的验证
    var myreg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
    if (!myreg.test(val)) {
      return false;
    }
    return true;
  },
  checkPhone(tel, isMobile) {
    var mobile = /^1[3|4|5|6|7|8|9]\d{9}$/, phone = /^0\d{2,3}-?\d{7,8}$/;
    if (isMobile) return mobile.test(tel);
    return mobile.test(tel) || phone.test(tel);
  },
  getPathByNodeIndexName(name) {
    let url = ""
    let routeName = ""
    switch (name) {
      case "About Us": url = "/about"; break;
      case "Business": url = "/product"; break;
      case "product": url = ""; break;
      case "development": url = "/management"; break;
      case "party": url = "/party"; break;
      case "companyculture": url = "/team"; break;
      case "mediacenter": url = "/news"; break;
      default: break;
    }
    routeName = url.split("/")[1]
    return { url: url, name: routeName };
  },
  /**
   * 获取一级菜单对象
   */
  getMenuCellByNodeIndexName(nodeIndexName) {
    let list = JSON.parse(localStorage.getItem("bwsteelMenus")) || null;
    if (!list) {
      return null;
    }
    let obj = null;
    list.forEach(item => {
      if (item.nodeIndexName === nodeIndexName) {
        obj = item;
      }
    });
    return obj;
  },
  getChildNodeId(nodeIndexName, childNodeIndexName) {
    let newsData = this.getMenuCellByNodeIndexName(nodeIndexName).childs;
    let nodeData = null
    newsData.forEach(item => {
      if (item.nodeIndexName == childNodeIndexName) {
        nodeData = item
      }
    })
    return nodeData
  },
  getRouteNameByNodeIndexName(nodeIndexName) {
    let aboutIndexNames = ["About Us", "brief", "vision", "managementaddress", "directors", "team"]
    let productIndexNames = ["Business", "Metalware"]
    let managementIndexNames = ["development", "map", "brace", "change", "history", "achievement", "honor"]
    let partyIndexName = ["party", "partynews"]
    let teamIndexName = ["companyculture", "growth", "employer", "growing", "realm"]
    let newsIndexName = ["mediacenter", "news", "companyvideo", "evideo", "Brochure"]
    let name = ""
    if (aboutIndexNames.includes(nodeIndexName)) {
      name = "about"
    } else if (productIndexNames.includes(nodeIndexName)) {
      name = "product"
    } else if (managementIndexNames.includes(nodeIndexName)) {
      name = "management"
    } else if (partyIndexName.includes(nodeIndexName)) {
      name = "party"
    } else if (teamIndexName.includes(nodeIndexName)) {
      name = "team"
    } else if (newsIndexName.includes(nodeIndexName)) {
      name = "news"
    }
    return name
  }
};
